<style lang="scss" scoped>

    .article-list {
        width: 1080px;
        margin: auto;
        padding: 20px 0 40px;

        .row {
            display: flex;
            flex-direction: row;
            padding: 20px 0;
            justify-content: space-between;

            img {
                display: block;
                width: 220px;
                height: 220px;
                border: 0;
            }

            .txt {
                width: 820px;

                .title {
                    display: flex;
                    flex-direction: row;

                    .t {
                        width: 650px;
                        font-size: 20px;
                        font-weight: 600;
                        height: 40px;
                    }

                    .time {
                        width: 170px;
                        text-align: right;
                        color: #999;
                    }
                }

                .desc {
                    font-size: 16px;
                    line-height: 36px;
                    position: relative;
                    border-top: 1px solid #7cb85a;
                    height: 144px;
                    padding-top: 15px;
                    overflow: hidden;
                    color: #777;

                    .line {
                        display: block;
                        width: 40px;
                        height: 5px;
                        background: #7cb85a;
                        font-size: 0;
                        position: absolute;
                        top: -3px;
                    }
                }
            }
        }
    }

    .pagination {
        padding-bottom: 60px;
        text-align: center;
    }
    .as_news_header {
        text-align: center;
    }
    .as_news_type {
        display:inline-block;
        width:180px;
        text-align: center;
    }
</style>
<template>
    <div class="container">
        <div class="page-header as_news_header">
            <router-link class="as_news_type" v-for="(cate, index) in categories"
                :to="{path: '/news', query: {category: cate}}">
                <h2>{{cate}}</h2>
                <div class="icon-xian" v-if="curIndex === index"></div>
            </router-link>
        </div>
        <div class="article-list">
            <div class="row" v-for="item in newsList">
                <router-link :to="{path:'/news/'+item.id}">
                    <img :src="item.imageUrl" :alt="item.title"/>
                </router-link>
                <div class="txt">
                    <div class="title">
                        <div class="t">
                            <router-link :to="{path:'/news/'+item.id}">{{item.title}}</router-link>
                        </div>
                        <div class="time">{{item.creationTime}}</div>
                    </div>
                    <div class="desc">
                        {{item.summary}}
                        <span class="line"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="pagination">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="listQuery.Page"
                :hide-on-single-page="true"
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="listQuery.Size">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'news',
        data() {
            return {
                loading: false,
                total: 0,
                newsList: [],
                listQuery: {
                    Category: "新闻",
                    Keywords: '',
                    Page: 1,
                    Size: 10
                },
                categories: [],
                curIndex: 0
            }
        },
        watch: {
            '$route'(){
                this.getData();
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                let query = this.$route.query;
                this.listQuery.Category = query.category || "新闻";
                this.getCategories(() => {
                    let index = this.categories.indexOf(this.listQuery.Category);
                    this.curIndex = index;
                    this.getNewsList()
                });
            },
            getNewsList() {
                this.showPcLoading()
                let par = `?Category=${this.listQuery.Category}&Page=${this.listQuery.Page}&Size=${this.listQuery.Size}`
                this.axios.get(window.consts.apis.getNews + par).then(res => {
                    this.hidePcLoading()
                    if (res.success) {
                        this.total = res.result.totalCount
                        this.newsList = res.result.items
                    } else {
                        this.$alert(res.error.message, '')
                    }
                }).catch(res => {
                    this.hidePcLoading()
                })
            },
            getCategories(callback) {
                this.showPcLoading()
                this.axios.get(window.consts.apis.getCategories).then(res => {
                    this.hidePcLoading()
                    if (res.success) {
                        this.categories = res.result;
                        callback();
                    } else {
                        callback();
                    }
                }).catch(res => {
                    this.hidePcLoading()
                    callback();
                })
            },
            handleCurrentChange(val) {
                this.listQuery.Page = val
                this.getNewsList()
            }
        }
    }
</script>
